"use client";

import { useTranslations } from "next-intl";

import { CustomDialog } from "@/components/custom/dialog";
import { Button } from "@/components/ui/button";
import { useRouter } from "next/navigation";

interface CancelSignUpConfirmModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  cancelPath?: string; //Custom path to navigate when cancel is clicked. Defaults to '/user/select-member-type'
}

export default function CancelSignUpConfirmModal({
  open,
  setOpen,
  cancelPath = "/user/select-member-type",
}: CancelSignUpConfirmModalProps) {
  const router = useRouter();
  const t = useTranslations("dialogs.cancelSignup");

  return (
    <CustomDialog
      open={open}
      onOpenChange={setOpen}
      size="xs"
      classNameTitle="text-xl"
      title={t("title")}
      description={
        <span className="whitespace-pre-line">
          {t.rich("description", {
            bold: (chunks) => <strong>{chunks}</strong>,
          })}
        </span>
      }
      buttons={
        <>
          <Button
            onClick={() => router.push(cancelPath)}
            size="lg"
            variant="secondary"
            tone={"light"}
            className="text-base font-semibold"
          >
            {t("cancelText")}
          </Button>
          <Button
            onClick={() => setOpen(false)}
            size="lg"
            className="text-base font-semibold"
          >
            {t("okText")}
          </Button>
        </>
      }
    />
  );
}
